import { useParams } from 'react-router-dom';
import MembersPanel from '../../components/members/MembersPanel';

export default function Team() {
  const { projectId } = useParams<{ projectId: string }>();
  if (!projectId) return null;
  return <MembersPanel projectId={projectId} />;
}
